import React from 'react';
import { useHistory } from 'react-router';
import FormSearchHotel from '@shared/pages/Hotels/FormSearchHotel';
import { HOTELS_SEARCH } from '@shared/helpers/routes';
import TabsHeader from '@shared/components/TabsHeader';
import HotelDetailStyled from './HotelDetailStyled';

export default () => {
  const history = useHistory();

  const setIsReadyToNavigate = v => {
    if (v) history.push(HOTELS_SEARCH);
  };
  return (
    <>
      <TabsHeader site={1} />

      <FormSearchHotel
        navigatesToSearch={false}
        needsNavigate={true}
        setReady={value => setIsReadyToNavigate(value)}
      />

      <HotelDetailStyled />
    </>
  );
};
